

















































































































































































































































































































































































import { Component, Prop, Provide, Vue, Watch } from "@/shared/vuepack";
import SideBar from "@/employee/components/healthcareExpenseV2/SideBar.vue";
import Widget from "@/shared/components/Widget.vue";
import CategoryPill from "@/shared/components/CategoryPill.vue";
import {
  FetchState,
  HsabExpenseCategory,
  hsabExpenseCategoryMap,
  HsabExpenseEvidenceShoeboxModalSource,
  HsabExpenseFormStep,
  HsabExpenseFormSubmitMethod,
  HsabExpenseFormType,
  HsabExpenseOriginator,
  HsabExpensePaymentStatus,
  HsabPayee,
  HsabRecipientType,
  HsabSsoDestination,
  HsabSubmitExpenseError,
  ManuallyMarkedAsPaidStatus,
  PayFromPlanOption,
  ProviderLookupItem,
} from "@/shared/types";

import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useFamilyStore } from "@/employee/store/family";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useExpenseV2Store } from "@/employee/store/expenseV2";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useHsabExpenseEvidenceStore } from "@/employee/store/hsabExpenseEvidence";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePayeeStore } from "@/employer/store/payee";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useThemeStore } from "@/shared/store/theme";
import { useUserStore } from "@/shared/store/user";

import EvidenceUpload from "@/shared/components/expenseV2/EvidenceUpload.vue";
import DenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseReimbursementDenialReason.vue";
import Button from "@/shared/components/ui/Button.vue";
import PayeeSelector from "@/employer/components/payees/PayeeSelector.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment-timezone";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import HsabInsuranceClaim from "@/employee/components/landing-pages/hsabank/expense/HsabInsuranceClaim.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabExpenseSubmitConfirmation from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseSubmitConfirmation.vue";
import HsabExpensePaymentDetails from "@/employee/components/landing-pages/hsabank/expense/HsabExpensePaymentDetails.vue";
import HsabExpensePayFromDisplay from "@/employee/components/landing-pages/hsabank/expense/HsabExpensePayFromDisplay.vue";
import HsabExpenseFormExpenseCategory from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseFormExpenseCategory.vue";
import HsabExpenseFormRecipients from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseFormRecipients.vue";
import HsabExpenseFormSchedule from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseFormSchedule.vue";
import HsabExpenseEvidenceShoeboxModal from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoeboxModal.vue";

import { formatCurrency } from "@/shared/currency.js";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import { Validator } from "vee-validate";
import _ from "lodash";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  computed: {
    HsabSsoDestination () {
      return HsabSsoDestination;
    },
    ManuallyMarkedAsPaidStatus () {
      return ManuallyMarkedAsPaidStatus;
    },
    FetchState () {
      return FetchState;
    }
  },
  components: {
    HsabExpenseFormRecipients,
    HsabExpenseFormExpenseCategory,
    SsoDeepLink,
    Button,
    Checkbox,
    GenericLoadingSpinner,
    EvidenceUpload,
    DenialReason,
    CategoryPill,
    HsabExpenseEvidence,
    HsabInsuranceClaim,
    HsabExpensePayFromDisplay,
    HsabExpensePaymentDetails,
    HsabExpenseFormSchedule,
    HsabExpenseSubmitConfirmation,
    PayeeSelector,
    Widget,
    SideBar,
    HsabExpenseEvidenceShoeboxModal,
  },
})
export default class HsabExpenseForm extends Vue {
  formatCurrency = formatCurrency;
  contactInformationStore = useContactInfoStore();
  themeStore = useThemeStore();
  payeeStore = usePayeeStore();
  expenseStore = useExpenseV2Store();
  userStore = useUserStore();
  hsabExpenseStore = useHsabExpenseStore();
  hsabExpenseEvidenceStore = useHsabExpenseEvidenceStore();
  balanceStore = useHsaDailyBalanceStore();
  hsabAccountsStore = useHsabAccountsStore();
  familyStore = useFamilyStore();
  featureFlagStore = useFeatureFlagStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();
  hsabExpenseEvidenceShoeboxStore = useHsabExpenseEvidenceShoeboxStore();
  notifierStore = useNotifierStore();
  portalCustomizationStore = usePortalCustomizationStore();
  bankAccountStore = useBankAccountStore();

  @Prop()
  hideExpenseHeader: boolean;

  @Prop()
  overrideSaveButtonText: string;

  showDeleteConfirmationModal = false;
  isUploadingFilesToSubmittedExpense = false;
  transactionType = 0;
  disableSaveButtons = false;
  isDirty = false;
  selectionChanged = false;
  selectedProvider: ProviderLookupItem = null;
  suggestions = [];
  debouncedSearch = _.debounce(searchTerm => this.fetchProviderList(searchTerm), 500);
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;
  formSubmitMethod: HsabExpenseFormSubmitMethod = HsabExpenseFormSubmitMethod.save;
  @Provide()
  $validator: Validator;
  timeZoneCST = "America/Chicago";

  created (): void {
    this.hsabAccountsStore.loadCanPerformWithdrawalFunction();
  }
  mounted () {
    this.$nextTick(() => {
      this.hsabExpenseFormStore.syncExpenseWithForm();
      if (!this.expense) {
        this.hsabExpenseStore.getProviderLookupPreCache();
      }
    });
  }
  get expenseForm () {
    return this.hsabExpenseFormStore.expenseForm;
  }
  get expense () {
    return this.hsabExpenseFormStore.expense;
  }

  get isPayToPayeeRequiredToSave () {
    return this.expenseForm.isPayToPayee && this.hsabExpenseFormStore.selectedPayee === null;
  }

  isDependentSelected = {
    getMessage () {
      return  "A dependent must be selected as the recipient for Dependent Care expenses.";
    },
    validate (value: HsabExpenseCategory, params: any) {
      const recipientType = params[0];
      const isRecipientSubscriberOrNone =
          recipientType === HsabRecipientType.Subscriber ||
          recipientType === HsabRecipientType.None;

      return !(isRecipientSubscriberOrNone && value === HsabExpenseCategory.DependentCare);
    }
  };

  isAccountHolderSelected = {
    getMessage () {
      return "Category is invalid for the selected recipient.";
    },
    validate (value: HsabExpenseCategory, params: any) {
      const recipientType = params[0];
      const isRecipientDependentOrNone =
          recipientType === HsabRecipientType.Dependant ||
          recipientType === HsabRecipientType.None;
      const hasMassTransitOrParking = (value === HsabExpenseCategory.MassTransit || value === HsabExpenseCategory.Parking);

      return !(isRecipientDependentOrNone && hasMassTransitOrParking);
    }
  };
  validateAmountIfPayFromIsHsa (x) {
    let result = true;

    if (this.hsabExpenseFormStore.hasExpenseForm &&
        this.isFormSubmitMethodSaveAndSubmit &&
        this.hsabAccountsStore &&
        this.hsabAccountsStore.userHasHsaAccount &&
        (this.hsabExpenseFormStore.payFromHasHsaOption && !this.hsabExpenseFormStore.payFromHasNotionalOption) || this.hsabExpenseFormStore.forceHsaPlans) {

      if (x > this.accountBalance) {
        result = false;
      }
    }

    return {
      valid: result,
      data: {
        required: true
      }
    };
  }

  validateAmountIfPayFromIsHsaMessage () {
    return "Expense amount exceeds your available HSA balance.";
  }

  hasValidAmountIfPayFromIsHsa = {
    getMessage: this.validateAmountIfPayFromIsHsaMessage,
    validate: this.validateAmountIfPayFromIsHsa,
  };

  hasValidFraudAmount = {
    getMessage: this.validateFraudMessage,
    validate: this.validateFraudAmount
  };

  hasValidDateOfExpense = {
    getMessage: this.validateDateOfExpenseMessage,
    validate: this.validateDateOfExpense
  };

  validateDateOfExpenseMessage () {
    return "Cannot submit expenses with future dates.";
  }

  @Watch("expenseForm.isPayToPayee")
  updateContactInfo () {
    if (!this.expenseForm.isPayToPayee) {
      this.contactInformationStore.getContactInformation();
    }
  }

  get showRequestRecurring () {
    return this.hsabAccountsStore.userHasActiveNotionalAccounts
        && this.hsabExpenseFormStore.payFromHasNotionalOption
        && !this.hsabExpenseFormStore.forceHsaPlans
        && (!this.hsabExpenseFormStore.hasExpense || this.expense.originator !== HsabExpenseOriginator.CarrierClaim);
  }

  beforeMount () {
    this.$validator.extend("validateFraudAmount", this.hasValidFraudAmount, { computesRequired: true });
    this.$validator.extend("required_to_save", this.validateRequiredToSave, { computesRequired: true });
    this.$validator.extend("required_to_submit", this.validateRequiredToSubmit, { computesRequired: true });
    this.$validator.extend("isDependentSelected", this.isDependentSelected, { computesRequired: true });
    this.$validator.extend("isAccountHolderSelected", this.isAccountHolderSelected, { computesRequired: true });
    this.$validator.extend("validateAmountIfPayFromIsHsa", this.hasValidAmountIfPayFromIsHsa, { computesRequired: true });
    this.$validator.extend("validateDateOfExpense", this.hasValidDateOfExpense, { computesRequired: true });
  }

  get readonly (): boolean {
    return this.hsabExpenseFormStore.isReadonly;
  }

  get isFieldReadOnly (): boolean {
    return this.readonly && !this.isExpenseSubmittedToHsa;
  }

  get isDateOfExpenseReadonly () {
    return this.isTalonClaim || this.expense
        && (this.isFieldReadOnly
            || (this.hasExternalId && !this.expense.isSubmitted)
            || (this.hsabExpenseFormStore.isImportedCarrierClaim && !this.expense.isSubmitted));
  }

  get showSubmitConfirmationStep () {
    return this.hsabExpenseFormStore.formStepToDisplay === HsabExpenseFormStep.confirmation;
  }

  get showScheduleStep () {
    return this.hsabExpenseFormStore.formStepToDisplay === HsabExpenseFormStep.schedule;
  }

  get showDetailsStep () {
    return this.hsabExpenseFormStore.formStepToDisplay === HsabExpenseFormStep.details;
  }

  get isAmountDisabled (): boolean {
    return this.readonly
      || this.hasExternalId
      || this.hsabExpenseFormStore.isImportedCarrierClaim
      || this.isLinkedToDebitCardTransaction
      || this.isTalonClaim;
  }
  get isTalonClaim (): boolean {
    return (this.expenseForm
      && this.expenseForm.hashValue !== undefined
      && this.expenseForm.hashValue !== null)
       || (this.expense && this.expense.linkedClaimNumbers !== null && this.expense.linkedClaimNumbers.length > 0);
  }

  get showPaymentFields (): boolean {
    const isMarkedAsPaid = this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid;

    if (this.expense) {
      return !this.isLinkedToDebitCardTransaction
          && !isMarkedAsPaid
          && !this.expense.isSubmitted;
    }

    return !this.isLinkedToDebitCardTransaction;
  }
  get isLinkedToDebitCardTransaction () {
    return this.expenseForm.linkedDebitCardTransactionId !== undefined
        && this.expenseForm.linkedDebitCardTransactionId !== null
        && this.expenseForm.linkedDebitCardTransactionId > 0;
  }

  get showReimburseTravelCosts () {
    return this.isMedicalCategorySelected && !this.isLinkedToDebitCardTransaction && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }

  get showRecurringTemplate () {
    return this.featureFlagStore.flags.bend25754RecurringHsaExpenses
        && this.hsabAccountsStore.userHasActiveHsaAccounts
        && this.hsabExpenseFormStore.expectedPayFromWillBeHsa;
  }

  @Watch("hsabExpenseFormStore.forceHsaPlans")
  onForceHsaPlansChanged (forceHsaPlans: boolean) {
    this.updateRecurringFlagsOnPayFromChanges();
  }

  get showEobNumber () {
    return this.hsabExpenseFormStore.hasExpenseForm && !isNullEmptyOrUndefined(this.expenseForm.externalReferenceId);
  }

  get showSaveButton () {
    return this.isExpenseSubmittedToHsa || !this.readonly;
  }

  get showSelectScheduleButton () {
    return this.expenseForm.isRecurringTemplate;
  }

  get showSubmitButton () {
    return !this.readonly
        && !this.isLinkedToDebitCardTransaction
        && !this.expenseForm.isRecurringTemplate
        && !(this.expenseForm && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid);
  }

  get showValidPreHsaStartDateExpense () {
    return this.hsabExpenseFormStore.isValidPreHsaStartDateExpense;
  }

  get hasExternalId () {
    return this.hsabExpenseFormStore.hasExpense && !isNullEmptyOrUndefined(this.expense.externalExpenseId);
  }

  get showManuallyPaidOption () {
    const isClaim = this.hsabExpenseFormStore.isImportedCarrierClaim || this.hsabExpenseFormStore.isInsuranceClaim;
    const hasReimbursement = this.expense && this.expense.reimbursement;
    return isClaim && !hasReimbursement;
  }

  get uploadFileCount () {
    let count = 0;
    if (this.hsabExpenseFormStore.hasExpense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.expenseForm.stagedFilesForUpload) {
      count += this.expenseForm.stagedFilesForUpload.length;
    }
    return count;
  }

  get isMedicalCategorySelected () {
    if (!this.hsabExpenseFormStore.currentlySelectedCategory) {
      return false;
    }
    switch (this.hsabExpenseFormStore.currentlySelectedCategory.category) {
      case HsabExpenseCategory.Medical:
      case HsabExpenseCategory.Vision:
      case HsabExpenseCategory.Dental:
      case HsabExpenseCategory.Pharmacy:
        return true;
      default:
        return false;
    }
  }
  get isFormSubmitMethodSaveAndSubmit () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.saveAndSubmit;
  }

  get isFormSubmitMethodSave () {
    return this.formSubmitMethod === HsabExpenseFormSubmitMethod.save;
  }

  get isAddingReceiptsAllowed () {
    if (!this.expense) {
      // creating new expense
      return true;
    }

    return this.expense.isFileUploadAllowed;
  }

  get eligibleAmountValidator () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01,
      validateFraudAmount: true,
      validateAmountIfPayFromIsHsa: true,
    };
  }

  get dateOfExpenseValidator () {
    return {
      required: true,
      validateDateOfExpense: true,
    };
  }

  get dateOfServiceAsMoment () {
    return moment(this.expenseForm.dateOfService);
  }

  get hasDenialReasons (): boolean {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.denialReasons
        && this.expense.reimbursement.denialReasons.length > 0;
  }

  get isAddingAdditionalEvidence () {
    return this.expenseForm && this.expenseForm.stagedFilesForUpload.length > 0;
  }

  get isExpenseSubmitted (): boolean {
    return this.hsabExpenseFormStore.hasExpense && this.expense.isSubmitted;
  }
  get hasInsuranceClaim (): boolean {
    return this.hsabExpenseFormStore.hasClaim;
  }
  get isExpenseSubmittedToHsa (): boolean {
    return this.hsabExpenseFormStore.isExpenseSubmittedToHsa;
  }

  get isFileUploadRequiredForSubmit (): boolean {
    if (this.hsabExpenseFormStore.hasClaim
      || this.hsabExpenseFormStore.isImportedCarrierClaim
      || this.hsabExpenseFormStore.isInsuranceClaim) {
      return false;
    }

    if (this.hsabExpenseFormStore.expectedPayFromWillBeHsa) {
      return false;
    }

    return this.hsabExpenseFormStore.payFromHasNotionalOption;
  }

  get tomorrow (): string {
    return moment.tz(this.timeZoneCST).endOf("day").add("1").format("YYYY-MM-DD");
  }

  get isSaving () {
    return this.hsabExpenseFormStore.isSaving;
  }

  get disableSubmitButton () {
    const isClaim = this.hsabExpenseFormStore.isImportedCarrierClaim || this.hsabExpenseFormStore.isInsuranceClaim;
    return this.isSaving
        || this.disableSaveButtons
        || !this.canPerformWithdrawal
        || !this.hsabAccountsStore.userHasAnyActiveAccount
        || this.hsabExpenseStore.isCategoryDataFailed
        || (isClaim && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.NotMarkedAsPaid);
  }

  get hasNotionalPayFromOptions (): boolean {
    return this.hsabExpenseFormStore.currentPayFromOptions.some(x => x.isHsa === false);
  }
  get canPerformWithdrawal (): boolean {
    if (!this.featureFlagStore.flags.bend27332ExpenseConsumerHoldFeature || this.hsabAccountsStore.isNotionalOnly) {
      return true;
    } else if (this.hsabExpenseFormStore.expectedPayFromWillBeNotional) {
      return true;
    }

    return this.hsabAccountsStore.canPerformWithdrawal;
  }

  get submitButtonTooltip () {
    if (this.hsabExpenseFormStore.isImportedCarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid) {
      return "Cannot submit an expense that has been marked as paid";
    } else if (this.hsabExpenseFormStore.isImportedCarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.Unknown) {
      return "Please select if this claim has already been paid or not";
    } else if (!this.canPerformWithdrawal) {
      return `You cannot submit an expense at this time. If you have questions please contact ${this.supportPhone}`;
    }
    return "";
  }
  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }
  get receiptRequiredToSubmit () {
    return this.isFileUploadRequiredForSubmit && this.uploadFileCount === 0 && !this.hsabExpenseFormStore.hasShoeboxEvidenceAttached;
  }

  get showReceiptRequiredToSubmit () {
    return this.isFormSubmitMethodSaveAndSubmit && this.receiptRequiredToSubmit;
  }

  get displayMoreActionsDropdown (): boolean {
    return this.hsabExpenseFormStore.hasExpense
        && !this.expense.isSubmitted
        && !this.isLinkedToDebitCardTransaction;
  }

  get showUnmarkedAsPaidAction (): boolean {
     return this.hsabExpenseFormStore.hasExpense
         && this.expense.externalPaymentStatus !== HsabExpensePaymentStatus.MarkedAsPaid
         && !this.hsabExpenseFormStore.isImportedCarrierClaim
         && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }

  get showMarkedAsPaidAction (): boolean {
    return this.hsabExpenseFormStore.hasExpense
        && !this.hsabExpenseFormStore.isImportedCarrierClaim
        && this.expenseForm.manuallyMarkedAsPaidStatus !== ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }

  get showMarkedAsPaidAlert (): boolean {
    return this.hsabExpenseFormStore.hasExpense
      && this.expense.externalPaymentStatus !== HsabExpensePaymentStatus.MarkedAsPaid
      && !this.hsabExpenseFormStore.isImportedCarrierClaim
      && this.expenseForm.manuallyMarkedAsPaidStatus === ManuallyMarkedAsPaidStatus.MarkedAsPaid;
  }

  get showCannotUnmarkAsPaidAlert (): boolean {
    return this.hsabExpenseFormStore.hasExpense
        && !this.hsabExpenseFormStore.isImportedCarrierClaim
        && this.expense.externalPaymentStatus === HsabExpensePaymentStatus.MarkedAsPaid;
  }

  onRecurringTemplateChanged (val) {
    if (val) {
      this.hsabExpenseFormStore.setDefaultSchedule();
    } else {
      this.hsabExpenseFormStore.clearCurrentSchedule();
    }
  }

  onIsPayToPayeeChanged () {
    this.$validator.validate("eligible amount");
  }

 markAsPaid () {
    if (this.expenseForm) {
      this.expenseForm.manuallyMarkedAsPaidStatus = ManuallyMarkedAsPaidStatus.MarkedAsPaid;
      this.handleSaveAction();
    }
  }

 unmarkAsPaid () {
    if (this.expenseForm) {
      this.expenseForm.manuallyMarkedAsPaidStatus = ManuallyMarkedAsPaidStatus.NotMarkedAsPaid;
      this.hsabExpenseStore.saveExpense(this.expenseForm);
    }
  }

  getExpensePayeeData (): HsabPayee {
    if ((this.expenseForm.hsabExpenseId && this.expenseForm.hsabExpenseId > 0 || this.hsabExpenseFormStore.selectedPayee) && this.expenseForm.isPayToPayee) {
      return {
        payeeName: this.expenseForm.payeeName,
        memberAccountNumber: this.expenseForm.payeeMemberNumber,
        address1: this.expenseForm.payeeAddress1,
        address2: this.expenseForm.payeeAddress2,
        city: this.expenseForm.payeeCity,
        stateCode: this.expenseForm.payeeStateCode,
        zip: this.expenseForm.payeeZipCode,
      };
    } else if (this.hsabExpenseFormStore.hasClaim) {
      return this.payeeStore.findPayee(this.hsabExpenseFormStore.claim.providerName);
    } else {
      return null;
    }
  }

  handleCancelAction () {
    this.hsabExpenseFormStore.expenseForm = { ...this.expense, hashValue: null, stagedFilesForUpload: [] };
    this.handleCloseAction();
  }

  handleCloseAction () {
    this.$emit("close-action");
  }

  closeDeleteConfirmationModal () {
    this.showDeleteConfirmationModal = false;
  }

  confirmDelete () {
    this.hsabExpenseStore.deleteExpense(this.expense.hsabExpenseId);
    this.closeDeleteConfirmationModal();
    this.handleCloseAction();
  }
  get accountBalance (): number {
    return this.hsabAccountsStore.findHsaAccount().accountBalance;
  }
  confirmSubmit () {
    this.hsabExpenseFormStore.isSaving = true;
    this.hsabExpenseStore.CreateOrUpdateExpenseAndSubmitForReimbursement(this.expenseForm)
        .then(_ => {
          this.hsabExpenseFormStore.isSaving = false;
          this.balanceStore.loadInstantBalance({ force: true });
          this.balanceStore.invalidateBalanceOnFileFetchState();
          this.balanceStore.loadBalanceOnFile();
          this.hsabAccountsStore.reloadHsabAccounts();
          this.hsabExpenseEvidenceShoeboxStore.loadPage(1);
        })
        .catch(failedStep => {
          switch (failedStep) {
            case HsabSubmitExpenseError.CreateExpense:
              break;
            case HsabSubmitExpenseError.UploadFiles:
            case HsabSubmitExpenseError.SubmitForReimbursement:
              break;
          }
          this.hsabExpenseEvidenceShoeboxStore.loadPage(1);
          this.hsabExpenseFormStore.isSaving = false;
        });
  }

  handleReimburseAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.saveAndSubmit;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
     if (!valid) {
        return;
      }
      if (this.receiptRequiredToSubmit) return;
      if (this.hsabExpenseFormStore.isPayFromRequiredToSubmit) return;
      this.hsabExpenseFormStore.formStepToDisplay = HsabExpenseFormStep.confirmation;
    });
  }

  addFiles (files) {
    this.expenseForm.stagedFilesForUpload = files;
  }

  handleSaveAction () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.save;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }

      this.hsabExpenseFormStore.isSaving = true;
      if (!this.expenseForm.isPayToPayee) {
        this.clearPayeeFormData();
      }
      this.hsabExpenseStore.saveExpense(this.expenseForm)
          .then(() => {
            this.hsabExpenseFormStore.isSaving = false;
            this.handleCloseAction();
          })
          .catch(() => {
            this.hsabExpenseFormStore.isSaving = false;
          });
    });
  }

  onSelectScheduleClicked () {
    this.formSubmitMethod = HsabExpenseFormSubmitMethod.saveAndSubmit;
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }

      this.hsabExpenseFormStore.formStepToDisplay = HsabExpenseFormStep.schedule;
    });
  }

  handleAddFilesAfterSubmitted () {
    if (!this.hsabExpenseFormStore.hasExpense || !this.expenseForm || !this.expenseForm.stagedFilesForUpload) {
      return;
    }

    this.isUploadingFilesToSubmittedExpense = true;
    this.hsabExpenseEvidenceStore.UploadFilesToSubmittedHsabExpense(
            this.expense.hsabExpenseId,
            this.expenseForm.stagedFilesForUpload,
            this.expense.reimbursement.isHsaReimbursement)
        .then(_ => {
          const managedExpensesStore = useManagedExpenseStore();
          managedExpensesStore.reloadCurrentPage();
          this.isUploadingFilesToSubmittedExpense = false;
          this.handleCloseAction();
        })
        .catch(err => {
          this.isUploadingFilesToSubmittedExpense = false;
        });
  }

  clearPayeeFormData () {
    this.expenseForm.payeeName = "";
    this.expenseForm.payeeMemberNumber = "";
    this.expenseForm.payeeAddress1 = "";
    this.expenseForm.payeeAddress2 = "";
    this.expenseForm.payeeCity = "";
    this.expenseForm.payeeStateCode = "";
    this.expenseForm.payeeZipCode = "";
  }

  onPayeeSelected (payee: HsabPayee) {
    if (payee) {
      this.expenseForm.payeeName = payee.payeeName;
      this.expenseForm.payeeMemberNumber = payee.memberAccountNumber;
      this.expenseForm.payeeAddress1 = payee.address1;
      this.expenseForm.payeeAddress2 = payee.address2;
      this.expenseForm.payeeCity = payee.city;
      this.expenseForm.payeeStateCode = payee.stateCode;
      this.expenseForm.payeeZipCode = payee.zip;
    } else {
      this.clearPayeeFormData();
    }
  }

  onPayeeEditStateChanged (isEditing: boolean) {
    this.disableSaveButtons = isEditing;
  }

  readonly payTypes = [
    { text: "Reimburse myself", value: false },
    { text: "Pay someone else", value: true }
  ];

  onTravelReimbursementChanged () {
    this.$validator.errors.remove("Number of miles");
    this.$validator.errors.remove("Mileage dollar value");
  }

  onTravelCostReimbursementEnabledChanged (val) {
    if (val === false) {
      this.expenseForm.numberOfMiles = undefined;
    }
  }

  isNullEmptyOrZero (val) {
    return val === undefined || val === null || val === "" || val === 0;
  }

  validateRequiredToSave (x) {
    return {
      valid: this.isFormSubmitMethodSave ? (x !== undefined && x !== null && x !== "") : true,
      data: {
        required: this.isFormSubmitMethodSave
      }
    };
  }

  validateRequiredToSubmit (x) {
    return {
      valid: this.isFormSubmitMethodSaveAndSubmit ? (x !== undefined && x !== null && x !== "" && x !== HsabExpenseCategory.Unknown) : true,
      data: {
        required: this.isFormSubmitMethodSaveAndSubmit
      }
    };
  }

  validateFraudMessage () {
    return "You cannot reimburse yourself from your HSA for more than $" + this.hsabExpenseStore.dailyReimburseMeLimitAmount + " in a single day.";
  }

  validateFraudAmount (x) {
    let result = true;

    const expenseFormIsSubmit = this.expenseForm && this.isFormSubmitMethodSaveAndSubmit;
    const amountOverLimit = this.hsabExpenseStore.reimbursedTodayAmount + x > this.hsabExpenseStore.dailyReimburseMeLimitAmount;

    if (expenseFormIsSubmit && amountOverLimit && this.bankAccountStore.hasDirectDepositAccount) {
      if (!this.hsabExpenseFormStore.excludeHsaPlans) {
        if (this.hsabExpenseFormStore.payFromHasHsaOption && !this.expenseForm.isPayToPayee) {
          result = false;
        }
      }
    }

    return {
      valid: result,
      data: {
        required: this.isFormSubmitMethodSaveAndSubmit
      }
    };
  }

  validateDateOfExpense (x) {
    let result = true;
    const dateOfService = moment(x);
    const today = moment().tz(this.timeZoneCST).endOf("day");

    if (this.isFormSubmitMethodSaveAndSubmit &&
        this.expenseForm &&
        dateOfService.isAfter(today)) {
      result = false;
    }

    return {
      valid: result,
      data: {
        required: this.isFormSubmitMethodSaveAndSubmit
      }
    };
  }

  onPayFromChange (options: PayFromPlanOption[]) {
    this.$validator.validate("eligible amount");

    this.updateRecurringFlagsOnPayFromChanges();
  }

  get showShoeboxModal (): boolean {
    return this.hsabExpenseEvidenceShoeboxStore.isModalOpen &&
        this.hsabExpenseEvidenceShoeboxStore.modalOpenedBy === HsabExpenseEvidenceShoeboxModalSource.expenseForm;
  }

  get expenseFormType (): HsabExpenseFormType {
    return HsabExpenseFormType.ExpenseManagement;
  }

  get shoeboxModalSource (): HsabExpenseEvidenceShoeboxModalSource {
    return HsabExpenseEvidenceShoeboxModalSource.expenseForm;
  }

  get showSearch (): boolean {
    return !this.readonly && this.featureFlagStore.flags.bend24837AllowMerchantAutoComplete;
  }

  updateRecurringFlagsOnPayFromChanges () {
    if (this.expenseForm.isRecurringTemplate && !this.hsabExpenseFormStore.expectedPayFromWillBeHsa) {
      this.expenseForm.isRecurringTemplate = false;
    }
    if (this.expenseForm.isRecurring && this.hsabExpenseFormStore.expectedPayFromWillBeHsa) {
      this.expenseForm.isRecurring = false;
    }
  }

  fetchProviderList (searchTerm: string): void {
    if (searchTerm.length >= 2) {
      this.hsabExpenseStore.getProviderSearchTypeAhead(searchTerm)
        .catch(this.handleError);
    }
  }
  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }
  showError (message: string): void {
    this.notifierStore.setDanger(message, 3000);
  }
  providerFormatForSearch (provider) {
    return provider.providerName;
  }
  formatProviderAddressLine1And2 (provider: ProviderLookupItem) {
    let result = provider.address1;
    if (provider.address2) {
      result += " " + provider.address2;
    }
    return result;
  }
  formatProviderAddressCityStateZip (provider: ProviderLookupItem) {
    let result = provider.city;
    if (provider.stateCode || provider.zipCode) {
      result += ", ";
      result += provider.stateCode;
      if (provider.zipCode) {
        result += " " + provider.zipCode;
      }
    }
    return result;
  }

  @Watch("hsabExpenseStore.providerSearchTypeAheadResult", { deep: true })
  updateEmployersSuggestions () {
    if (this.hsabExpenseStore.providerSearchTypeAheadResult) {
      this.suggestions = this.hsabExpenseStore.providerSearchTypeAheadResult.providers;
    }
    this.isDirty = false;
  }

  @Watch("hsabExpenseFormStore.excludeHsaPlans")
  onExcludeHsaPlansChanged () {
    this.$validator.validate("eligible amount");
  }

  @Watch("expenseForm.providerName")
  onSearchTermChange (searchValue): void {
    if (this.selectedProvider) {
      if (this.selectionChanged) {
        this.selectionChanged = false;
        return;
      }
      this.selectedProvider = null;
      this.$emit("select-provider", null);
    }
    this.isDirty = true;
    this.debouncedSearch(searchValue);
  }

  handleSelectionChanged (value: ProviderLookupItem) {
    this.selectedProvider = value;
    this.hsabExpenseFormStore.setProvideLookupItem(value);
    this.selectionChanged = true;
  }
}
